<template>
  <main class="home">
    <Header />
    <div class="container">
      <PersonLogin />
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Header from "@/apps/person-registration/shared-components/common/Header.vue";
import PersonLogin from "@/apps/person-registration/login/components/PersonLogin.vue";

export default defineComponent({
  name: "PersonLoginView",
  components: {
    Header,
    PersonLogin,
  },
});
</script>
